import axios from "../api";
import {objectToParam} from "../../libs/utils";
import {Certificate, FrequentPassageRequest, QueryListResult} from "../../hooks/api/utils/types";
import {RejectFrequentPassageRequestRequest} from "./frequentPassageRequests";
import {UseRejectCertificateParams} from "../../hooks/api/certificates/useRejectCertificate";

export async function getCompanyUserCertificates(companyId: number, userId: number, params: any = {}): Promise<QueryListResult<Certificate>> {
    const parameters = objectToParam(params);
    const {data} = await axios.get(
        `companies/${companyId}/users/${userId}/certificates?` + parameters
    );
    return data;
}

export type CreateCertificateRequest = Pick<Certificate, 'description' | 'type' | 'expiresAt' | 'files'>

export async function updateCompanyUserCertificate(companyId: number, userId: number, certificateId: number, values: any): Promise<Certificate> {
    const {data} = await axios.patch(
        `companies/${companyId}/users/${userId}/certificates/${certificateId}`,
        values
    );

    return data;
}

export async function getCertificates(params: any = {}): Promise<QueryListResult<Certificate>> {
    const parameters = objectToParam(params);
    const {data} = await axios.get(
        "certificates?" + parameters
    );
    return data;
}

export async function getCertificate(id: number, filters: any = {}): Promise<Certificate> {
    const parameters = objectToParam(filters);
    const {data} = await axios.get(
        "certificates/" + id + "?" + parameters
    );
    return data;
}

export async function createCertificate(values: any): Promise<Certificate> {
    const {data} = await axios.post("certificates", values);

    return data;
}

export type UpdateCertificateRequest = {
    // TODO
}

export async function updateCertificate(id: number, values: UpdateCertificateRequest): Promise<Certificate> {
    const {data} = await axios.patch(
        "certificates/" + id,
        values
    );
    return data;
}

export async function deleteCertificate(id: number): Promise<{}> {
    const {data} = await axios.delete("certificates/" + id);
    return data;
}

export type RejectCertificateRequest = {
    internalComment: string|null;
    publicComment: string|null;
    expiresAt: string|null;
}
export async function rejectCertificate(
    id: number,
    values: RejectCertificateRequest
): Promise<Certificate> {
    const {data} = await axios.post(
        `/certificates/${id}/reject`,
        values
    );

    return data;
}

export type ApproveCertificateRequest = {
    internalComment: string|null;
    publicComment: string|null;
    expiresAt: string;
}
export async function approveCertificate(id: number, values: ApproveCertificateRequest): Promise<Certificate> {
    const {data} = await axios.post(`/certificates/${id}/approve`, values);

    return data;
}
